import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NgrxService } from 'src/app/services/ngrx/ngrx.service';
import { map, tap } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ScheduleService {
	constructor(private http: HttpClient, private ngrxService: NgrxService) {}

	loadScheduleinit(jobFairId: any) {
		return this.ngrxService.loadInitAPI('Schedule', 'list', jobFairId);
	}

	loadScheduleapi(jobFairId: number) {
		return this.getScheduleList(jobFairId).pipe(
			map((data: any) => {
				data.data = data.data.sort(
					(a: any, b: any) => a.startTime - b.startTime,
				);
				return this.ngrxService.loadInitData(
					'Schedule',
					'list',
					jobFairId,
					data.data,
				);
			}),
		);
	}

	fetchScheduledata(jobFairId: any) {
		return this.ngrxService.loadData('Schedule', 'list', jobFairId);
	}

	getScheduleList(jobFairId: number) {
		return this.http.get(
			environment.url.company + `/jobfair/${jobFairId}/list/schedule`,
		);
	}

	addUpdateSchedule(id: number, companyId: number, content: any) {
		return this.http
			.post(
				environment.url.company +
					`/jobfair/${id}/company/${companyId}/schedule`,
				content,
				{},
			)
			.pipe(
				tap(data => {
					this.loadScheduleapi(id).subscribe();
				}),
			);
	}

	deleteSchedule(id: number, companyId: number) {
		// let scheduleList = [];
		// this.fetchScheduledata(id).subscribe(({ data }: any) => {
		// 	if (data) {
		// 		scheduleList = data.filter((data: any) => {
		// 			console.log(data.companyId, companyId, 'matrch');
		// 			return data.companyId !== companyId;
		// 		});
		// 	} else {
		// 		scheduleList = [];
		// 	}
		// 	this.ngrxService.loadInitData('Schedule', 'list', id, scheduleList);
		// });
		return this.http
			.delete(
				environment.url.company +
					`/jobfair/${id}/company/${companyId}/schedule`,
			)
			.pipe(tap(() => this.loadScheduleapi(id).subscribe()));
	}
}
